import { useQuery } from '@tanstack/react-query';
import { HttpService } from '@Services/api/httpService';
import type { SocureData } from '@Hooks/socure/useSocureBaseLogic';

export const resendUboDocV = async (customerId: string): Promise<SocureData> => {
  const url = `v1/onboarding/secondary/${customerId}/resendDocV`;
  const { data } = await HttpService.get<SocureData>(url);
  return data;
};

export const useResendUboDocV = (customerId: string) =>
  useQuery({
    queryFn: () => resendUboDocV(customerId),
    queryKey: ['resendUboDocV', customerId],
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
